export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-960-ee7d02618b361624901963a54142ee41.webp";